let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dkOOG")).then(() => parcelRequire('k3cYy'));